import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals/globals';
import { ImportFileTypes } from 'src/app/shared/models/data/importFileTypes.model';
import { Mill } from 'src/app/shared/models/data/itemParametersValues.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftModalService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-modal.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';

@Component({
  selector: 'app-import-masterdata',
  templateUrl: './import-masterdata.component.html',
  styleUrls: ['./import-masterdata.component.scss']
})
export class ImportMasterdataComponent implements OnInit, OnDestroy {
  @Input() isMobile!: boolean;

  entitiesOptionList: SelectOption[] = new Array();
  millsOptionList: SelectOption[] = new Array();
  selectedEntity: string | undefined;
  selectedMill: string | undefined;
  fileToUpload: File | undefined;
  subscriptions: Subscription = new Subscription();
  importFileTypes: ImportFileTypes[] = new Array();
  mills: Mill[] | undefined;


  constructor(public globals: Globals, private backendService: BackendService, private teiasoftLoader: TeiasoftLoaderService, private translate: TranslateService, private teiasoftModalService: TeiasoftModalService, private utils: UtilsService) {

  }

  ngOnInit(): void {
    this.teiasoftLoader.start();
    this.loadFileTypes();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  loadFileTypes() {
    this.subscriptions.add(this.backendService.getImportFileTypes().subscribe(res => {
      this.importFileTypes = res.importFileTypes!;
      this.initOptionsList();
      this.teiasoftLoader.stop();
    }));
  }

  initOptionsList() {
    const emptyOption = new SelectOption();
    emptyOption.text = '';
    emptyOption.value = '';

    this.entitiesOptionList = new Array();
    this.entitiesOptionList.push(emptyOption);

    this.importFileTypes.forEach((e) => {
      const sc = new SelectOption();
      sc.text = e.fileTypeText;
      sc.value = e.fileType;
      this.entitiesOptionList.push(sc);
    })
  }

  initMillsOptionsList() {
    const emptyOption = new SelectOption();
    emptyOption.text = '';
    emptyOption.value = '';

    this.millsOptionList = new Array();

    if (this.mills)
      this.mills.forEach((e) => {
        const sc = new SelectOption();
        sc.text = e.shortName;
        sc.value = e.millId;
        this.millsOptionList.push(sc);
      })
  }

  onSelectedEntity($event: SelectOption) {
    this.selectedEntity = $event.value;
    this.selectedMill = undefined;
    this.mills = this.importFileTypes.find(e => e.fileType == this.selectedEntity)?.mills;
    this.initMillsOptionsList();
  }

  onSelectedMill($event: SelectOption) {
    this.selectedMill = $event.value;
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.fileToUpload = file;

      this.uploadMasterDataFile(file);
    }
    input.value = '';

  }

  uploadMasterDataFile(evt: File) {
    this.teiasoftLoader.start();

    const reader = new FileReader();
    reader.onload = () => {
      const filecContent = (reader.result as string).split(',')[1]; // Get base64 content

      this.uploadMasterData(this.selectedEntity!, filecContent, Number(this.selectedMill));
    }

    reader.readAsDataURL(evt);
  }

  uploadMasterData(fileType: string, filecContent: string, millId: number) {
    this.subscriptions.add(this.backendService.uploadMasterData(fileType, filecContent, millId).subscribe({
      next: (res) => {
        if (res.isImportSucceeded)
          this.teiasoftModalService.show('info', this.translate.instant('importMasterdata.importSuccess'), res.importResultDescription!, '', '');
        else
          this.teiasoftModalService.show('info', this.translate.instant('importMasterdata.importFail'), res.importResultDescription!, '', '');

      },

      complete: () => {
        this.teiasoftLoader.stop();
        this.selectedEntity = '';
        this.selectedMill = '';
      }
    }));
  }

  onDownloadClick(includeData: boolean = false) {
    this.subscriptions.add(this.backendService.downloadMasterDataTemplate(this.selectedEntity!, Number(this.selectedMill), includeData).subscribe({
      next: (res) => {
        if (res)
          window.open(res.presignedUrl, '_blank');
      },

      complete: () => {
        this.teiasoftLoader.stop();
        this.selectedEntity = '';
        this.selectedMill = '';
      }
    }));
  }
}
